import * as actions from './articles/actions'
import * as mutations from './articles/mutations'
import * as getters from './articles/getters'

import { basicProps } from './articles/properties'

const state = {
    filterText: '',
    list: [],
    props: JSON.parse(JSON.stringify(basicProps))
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/articles.js